<template>
  <div>
    <van-row>
      <van-col :span="24" class="teacherDiv">
        <van-row v-if="liveList.length > 0">
          <van-col
            :span="24"
            v-for="(item, index) in liveList"
            :key="index"
            class="bg-white xzLiveItem"
            style="box-shadow: 0px 0px 8px 1px rgba(0, 6, 22, 0.04)"
          >
            <van-row class="xz-p-05">
              <van-col :span="6" class="xz-relative">
                <span class="teacherNameStyle">{{ item.live.teachers }}</span>
                <van-image
                  width="3.75rem"
                  height="5rem"
                  lazy-load
                  :src="item.live.teacherurl"
                  radius="5px"
                />
              </van-col>
              <van-col :span="17" :offset="1">
                <van-row class="xz-minH">
                  <div class="van-multi-ellipsis--l2 liveTitle ft16 gray-3">
                    <van-tag
                      type="danger"
                      class="m-r-8 todayLive"
                      v-if="item.today"
                      >今日直播</van-tag
                    >
                    <van-tag
                      type="danger"
                      class="m-r-8 xz-button-grey"
                      v-if="item.live.itname != null && item.live.itname != ''"
                      >{{ item.live.itname }}</van-tag
                    >{{ item.live.subject }}
                  </div>
                  <!-- line-height:0.9rem -->
                  <van-row>
                    <van-tag
                      color="#f6f6f6"
                      text-color="#ABAEB2"
                      class="liveTime"
                      >直播时间：{{ item.live.livestartDate }}-{{
                        item.live.liveendDate
                      }}</van-tag
                    >
                  </van-row>
                </van-row>
                <van-row class="m-t-3 xz_LiveItem_Footer">
                  <van-icon :name="people" size="0.6rem" />
                  <span class="baseNum">预约人数:{{ item.live.baseNum }}</span>
                  <van-button
                    size="mini"
                    :style="[
                      {
                        color: item.live.bookStare == '1' ? 'white' : '#FE7C12',
                      },
                      btnBgColor(item),
                    ]"
                    class="f-l-r xzLiveBtn"
                    :disabled="
                      item.live.bookStare == '1' && item.live.livestate != '2'
                    "
                    @click="appointmentLive(item)"
                  >
                    {{
                      item.live.livestate == "2"
                        ? "进入直播"
                        : item.live.bookStare == "1"
                        ? "已预约"
                        : "预约直播"
                    }}
                  </van-button>
                </van-row>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
    <!-- 预约直播弹出框 -->
    <van-overlay :show="show" @click="closeAppontLiveOver" z-index="2">
      <div class="wrapper" @click.stop>
        <!-- <div class="block" /> -->
        <div class="block" style="width: 80%; height: 15rem">
          <van-row>
            <van-col :span="24" class="text-r" @click="closeAppontLiveOver">
              <span class="m-r-8">×</span>
            </van-col>
            <van-col :span="24" class="text-c">
              <!-- <van-icon name="success" /> -->
              <!-- <van-icon name="success" /> -->
              预约成功
            </van-col>
            <van-col
              :span="24"
              class="text-c f-s-16"
              style="margin-top: 0.5rem"
            >
              关注公众号,获取更多课程通知
            </van-col>
            <van-col :span="24" class="text-c" style="margin-top: 0.5rem">
              <van-image
                width="5.45rem"
                height="5.45rem"
                src="https://webxiaozhu.oss-cn-beijing.aliyuncs.com/images/qrcode_for_gh_028263ec57bf_430.jpg"
              />
            </van-col>
            <van-col :span="24" class="text-c" style="margin-top: 1rem">
              <van-button
                type="primary"
                style="border-radius: 1.3rem"
                @click="openWX"
                >{{ btnText }}
              </van-button>
            </van-col>
          </van-row>
        </div>
      </div>
    </van-overlay>
    <!-- 绑定微信QQ弹出框 -->
    <van-overlay :show="bindingType">
      <div class="wrapper" @click.stop>
        <!-- <div class="block" /> -->
        <div
          class="block"
          style="width: 80%; height: 15rem; border-radius: 0.3rem"
        >
          <Binding @closeBinding="closeBinding" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getAppClient } from "@/utils/commonUtils";
import Binding from "@/components/liveList/binding";

export default {
  props: {
    liveList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    Binding,
  },
  created() {
    let belong = this.$route.query.belong;
    if (this.isNotNull(belong) && belong != this.getLocal("belong")) {
      this.setLocal("belong", belong);
    }
  },
  data() {
    return {
      // liveList: [{ live: { teachers: "乐乐" } },{ live: { teachers: "乐乐" } }],
      people: require("@/assets/imgs/people.png"),
      show: false,
      bindingType: false,
    };
  },
  methods: {
    btnBgColor(item) {
      if (item.live.livestate == "2") {
        return {
          background:
            "linear-gradient(90deg, #FE7B10 0%, #F89348 100%, #FF9C57 100%)",
          color: "white",
        };
      } else if (item.live.bookStare == "1") {
        return { background: "#F2F2F2", color: "#B1B1B9" };
      } else if (item.live.bookStare == "2") {
        return {
          background:
            "linear-gradient(90deg, #FFEADB 0%, #FFEADB 100%, #FF9C57 100%)",
          color: "#FE7C12",
        };
      }
    },
    // 预约成功，跳转微信
    openWX() {
      if (getAppClient() == "JSAPI") {
        return;
      } else {
        window.location.href = "weixin://";
        this.closeAppontLiveOver();
      }
    },
    // 关闭绑定对话框
    closeBinding() {
      this.bindingType = false;
    },
    closeAppontLiveOver() {
      this.show = !this.show;
    },
    // 打开预约成功对话框
    appointmentLive(entity) {
      if (localStorage.getItem("setToken") == null) {
        // false  没有登录   true  登录
        this.goLogin();
        return false;
      } else if (
        entity.live.livestate == "2" &&
        localStorage.getItem("wxOpenidType") == null &&
        localStorage.getItem("qqOpenidType") == null
      ) {
        this.bindingType = true; // 打开绑定微信和QQ的对话框
        return false;
      }
      if (entity.live.livestate == "2") {
        this.Api({
          url:this.getBelong() == null ? "api/live/gotoLiveBroadcast?liveId=" +
                entity.live.id +
                "&uid=" +
                localStorage.getItem("uid") + '&deviceId=' + this.getSession('ip')
              : "api/live/gotoLiveBroadcast?liveId=" +
                entity.live.id +
                "&belong=" +
                this.getBelong() +
                "&uid=" +
                localStorage.getItem("uid") + '&deviceId=' + this.getSession('ip'),
        })
          .then((res) => {
            this.$router.push({
              path: "/lookLive",
              query: { lookDress: res.data.studenturl },
            });
          })
          .catch((err) => {
            alert("打开直播间失败,请联系学习规划老师");
            console.log(JSON.stringify(err));
          });
      } else if (entity.live.bookStare != "1" && entity.live.livestate != "2") {
        this.Api({
          url:
            this.getBelong() == null
              ? "api/live/bookLiveBroadcast?liveId=" +
                entity.live.liveid +
                "&uid=" +
                localStorage.getItem("uid")
              : "api/live/bookLiveBroadcast?liveId=" +
                entity.live.liveid +
                "&belong=" +
                this.getBelong() +
                "&uid=" +
                localStorage.getItem("uid"),
          method: "GET",
        })
          .then((res) => {
            if (res.retuCode == 5000) {
              entity.live.bookStare = "1";
              entity.live.baseNum += 1;
              this.show = true;
            } else alert("预约失败,请联系学习规划老师");
          })
          .catch(() => {
            alert("预约未知错误,请联系学习规划老师");
          });
      }
    },
  },
  computed: {
    //
    btnText() {
      return getAppClient() == "JSAPI"
        ? "长按识别二维码"
        : "截图保存二维码,打开微信扫一扫";
    },
    // 登录的状态
    loginType() {
      return this.$store.state.Login.isUser;
    },
    QQLoginType() {
      // QQ绑定的状态
      return this.$store.state.Login.qqBingType;
    },
    wxLoginType() {
      // 微信绑定的状态
      return this.$store.state.Login.wxBingType;
    },
  },
};
</script>

<style lang="less" scoped>
.baseNum {
  font-size: 0.65rem;
  margin-left: 0.2rem;
}
.xz_LiveItem_Footer {
  color: #73787f;
  line-height: 1rem;
}
.xzLiveItem {
  max-height: 6rem;
  margin-top: 0.5rem;
  border-radius: 5px;
}
// 直播列表按钮样式
.xzLiveBtn {
  border-radius: 0.8rem;
  font-size: 0.6rem;
  height: 1.3rem;
  line-height: 1.3rem;
  background: linear-gradient(90deg, #ffeadb 0%, #ffeadb 100%, #ff9c57 100%);
  border: none;
  width: 3.6rem;
}
// 今日直播
.todayLive {
  font-size: 0.6rem;
  padding-top: 0.1rem;
  line-height: 0.8rem;
}
// 直播时间
.liveTime {
  font-size: 0.5rem;
  line-height: 0.7rem;
  padding: 0.1rem;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}
.teacherNameStyle {
  color: #ffffff;
  font-size: 0.55rem;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0.15rem;
  position: absolute;
  bottom: 0.5rem;
  z-index: 1;
  right: 0.5rem;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}
.teacherDiv {
  border-radius: 0.3rem;
}
.liveTitle {
  font-weight: 500;
  line-height: 1.1rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
* {
  font-family: "微软雅黑";
}
</style>
